import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Import getStorage from firebase/storage
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDjzHSkunPZZsIiR_Ap8B9vXWCQyTyZpgc",
    authDomain: "scholarship-10c69.firebaseapp.com",
    databaseURL: "https://scholarship-10c69-default-rtdb.firebaseio.com",
    projectId: "scholarship-10c69",
    storageBucket: "scholarship-10c69.appspot.com",
    messagingSenderId: "896433300078",
    appId: "1:896433300078:web:9bf2c85f6a764854843c7f"
};
const firestoreApiBaseUrl = "https://firestore.googleapis.com/v1/projects/scholarship-10c69/databases/(default)/documents";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app); // Import getStorage from firebase/storage
const auth = getAuth(app);

export { app, db, auth, storage }; // Export auth along with app, db, and storage
export default db;
